module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/virgin-b1ab8f5632745169d38fabb2a0ef22be.png";